import request from '../utils/request'

// dubbing api都是与草稿有关的

/**
 * 获取用户配音草稿
 * @param {Object} data
 */
export function listDubDraft (data) {
  return request({
    url: '/dubbing/list/v2',
    method: 'post',
    data
  })
}

/**
 * 上传用户配音草稿
 * @param {Object} data
 */
export function uploadDubDraft (data) {
  return request({
    url: '/dubbing/upload',
    method: 'post',
    data
  })
}

/**
 * 修改用户配音草稿
 * @param {Object} data
 */
export function updateDubDraft (data) {
  return request({
    url: '/dubbing/update',
    method: 'post',
    data
  })
}

/**
 * 删除用户配音草稿
 * @param {Object} data
 */
export function deleteDubDraft (data) {
  return request({
    url: '/dubbing/delete',
    method: 'post',
    data
  })
}

/**
 * 多选删除配音草稿箱
 * @param {Object} data
 */
 export function deleteDubDraftArray (data) {
  return request({
    url: '/dubbing/delete_array',
    method: 'post',
    data
  })
}
